(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/text-field.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/text-field.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Form = svs.ui.reactForm.Form;
const TextInput = svs.ui.reactFormInputs.TextInput;
const Button = svs.ui.ReactButton;
const MAX_MESSAGE_LENGTH = svs.arena.constants.MAX_MESSAGE_LENGTH;
const TextField = _ref => {
  let children = _ref.children,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? () => {} : _ref$onSubmit,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'Skicka e-post' : _ref$buttonText,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Skriv meddelande' : _ref$label,
    _ref$onHide = _ref.onHide,
    onHide = _ref$onHide === void 0 ? () => {} : _ref$onHide;
  const _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    message = _React$useState2[0],
    setEmail = _React$useState2[1];
  const handleChange = e => {
    e.stopPropagation();
    const text = e.target.value;
    if (text.length > MAX_MESSAGE_LENGTH) {
      return;
    }
    setEmail(text);
  };
  const onSubmitProcess = e => {
    onSubmit(message);
    e.preventDefault();
  };
  const handleKeyDown = e => {
    e.stopPropagation();
  };
  return React.createElement(Form, {
    method: "post",
    onSubmit: onSubmitProcess
  }, children, React.createElement("div", {
    className: "data-hj-suppress"
  }, React.createElement(TextInput, {
    infoMessage: "Antal tecken kvar : ".concat(MAX_MESSAGE_LENGTH - message.length),
    isLessSpace: true,
    label: label,
    multiline: true,
    name: "email",
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    rows: 3,
    value: message
  })), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    inverted: true,
    type: "submit"
  }, buttonText), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    onClick: onHide,
    transparent: true
  }, "Avbryt"));
};
svs.arena.pages.teams.components.TextField = TextField;

 })(window);